<ui-modal data-testid="new-doc-modal">
  <h5>{{ 'MODEL.NEW.TITLE' | transloco }}</h5>
  <ng-container>
    <div class="form">
      <div class="form-content">
        <div class="form-content-item">
          <span class="form-content-item-label">{{ 'MODEL.NEW.NAME.LABEL' | transloco }}</span>
          <ui-text-field data-testid="flow-name-input" class="form-content-item-text-field" [(value)]="contractModelName"
            [placeholder]="'MODEL.NEW.NAME.PLACEHOLDER' | transloco"></ui-text-field>
        </div>

        <div class="form-content-item introduction">
          <span class="form-content-item-label introduction">{{ 'MODEL.NEW.INTRODUCTION.LABEL' | transloco }}</span>
          <ui-text-area-field data-testid="flow-intro-input" class="form-content-item-text-area-field" [(value)]="introductionText"
            [placeholder]="'MODEL.NEW.INTRODUCTION.PLACEHOLDER' | transloco"></ui-text-area-field>
        </div>

        <div class="form-content-item">
          <span class="form-content-item-label">{{ 'MODEL.NEW.GROUP' | transloco }}</span>
          <ui-select-field data-testid="category-select" class="form-content-item-select" [options]="groupsOptions()" [(value)]="modelGroupId"></ui-select-field>
        </div>

        <div class="form-content-actions">
          <ui-button data-testid="new-doc-cancel-btn" size="large" color="onLight" [secondary]="true" (click)="onClose()">{{ 'COMMON.CANCEL' | transloco
            }}</ui-button>
          <ui-button data-testid="new-doc-save-btn" size="large" color="onLight" [loading]="saving()" (click)="onSave()">{{ 'COMMON.SAVE' | transloco
            }}</ui-button>
        </div>
      </div>
    </div>
  </ng-container>
</ui-modal>